// extracted by mini-css-extract-plugin
export default {"card":"bm_dl","quizImg":"bm_dm","overlay":"bm_dn","quizBtn":"bm_dp"};